/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ExchangeCancelCategory
 */
export interface ExchangeCancelCategory {
    /**
     * 환급 불가 사유 id
     * @type {number}
     * @memberof ExchangeCancelCategory
     */
    'exchangeCancelCategoryId': number;
    /**
     * 이름
     * @type {string}
     * @memberof ExchangeCancelCategory
     */
    'name': ExchangeCancelCategoryNameEnum;
}

export const ExchangeCancelCategoryNameEnum = {
    ExchangeableAmountLessThanAmountRequest: 'exchangeableAmountLessThanAmountRequest',
    ReasonsForReceivingBank: 'reasonsForReceivingBank',
    AccountHolderNameIsDifferent: 'accountHolderNameIsDifferent',
    RevokedAccount: 'revokedAccount',
    SuspendedAccount: 'suspendedAccount',
    Other: 'other'
} as const;

export type ExchangeCancelCategoryNameEnum = typeof ExchangeCancelCategoryNameEnum[keyof typeof ExchangeCancelCategoryNameEnum];


